import { qaTransport } from "@/src/config/qaTransport.js";

export default {
  async initializeWorkspace() {
    try {
      const res = await qaTransport.post("/qa/initialize");
      return res.data;
    } catch (error) {
      console.error("An error occurred while initializing QA workspace: ", error);
      throw error;
    }
  },

  async getInitStatus() {
    try {
      const res = await qaTransport.get("/qa/status");
      return res.data;
    } catch (error) {
      console.error("An error occurred while fetching QA init status: ", error);
      throw error;
    }
  },

  async createSuite(spaceId, data) {
    try {
      const res = await qaTransport.post(`/qa/spaces/${spaceId}/suites`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating suite: ", error);
      throw error;
    }
  },

  async updateSuite(id, data) {
    try {
      const res = await qaTransport.patch(`/qa/suites/${id}`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating suite: ", error);
      throw error;
    }
  },

  async deleteSuite(id) {
    try {
      const res = await qaTransport.delete(`/qa/suites/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting suite: ", error);
      throw error;
    }
  },

  async createConfiguration(data) {
    try {
      const res = await qaTransport.post("/qa/configurations", data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating configuration: ", error);
      throw error;
    }
  },

  async listConfigurations(body) {
    try {
      const res = await qaTransport.post("/qa/configurations/list", body);
      return res.data;
    } catch (error) {
      console.error("An error occurred while listing configurations: ", error);
      throw error;
    }
  },

  async updateConfiguration(id, data) {
    try {
      const res = await qaTransport.patch(`/qa/configurations/${id}`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating configuration: ", error);
      throw error;
    }
  },

  async deleteConfiguration(id) {
    try {
      const res = await qaTransport.delete(`/qa/configurations/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting configuration: ", error);
      throw error;
    }
  },

  async createCredential(data, suiteId) {
    try {
      const res = await qaTransport.post(`/qa/suites/${suiteId}/credentials`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while creating credential: ", error);
      throw error;
    }
  },

  async listCredentials(body, suiteId) {
    try {
      const res = await qaTransport.post(`/qa/suites/${suiteId}/credentials/list`, body);
      return res.data;
    } catch (error) {
      console.error("An error occurred while listing credentials: ", error);
      throw error;
    }
  },

  async updateCredential(id, data) {
    try {
      const res = await qaTransport.patch(`/qa/credentials/${id}`, data);
      return res.data;
    } catch (error) {
      console.error("An error occurred while updating credential: ", error);
      throw error;
    }
  },

  async deleteCredential(id) {
    try {
      const res = await qaTransport.delete(`/qa/credentials/${id}`);
      return res.data;
    } catch (error) {
      console.error("An error occurred while deleting credential: ", error);
      throw error;
    }
  },
};
